import { render, staticRenderFns } from "./EditCommand.vue?vue&type=template&id=50f128d5&"
import script from "./EditCommand.vue?vue&type=script&lang=js&"
export * from "./EditCommand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports